export const SET_STEP = 'SET_STEP';
export const SET_INITIALIZE = 'SET_INITIALIZE';
export const SET_INFO_SALE_NOTE = 'SET_INFO_SALE_NOTE';